import React from 'react'
import ReactDOM from 'react-dom/client'
import { Suggest, Search } from './Search'

const backend = document.querySelectorAll('.neos-backend')

if (!backend.length) {
    document.querySelectorAll('.js-suggest').forEach((suggest) => {
        ReactDOM.createRoot(suggest).render(<Suggest config={suggest.dataset} />)
    })

    document.querySelectorAll('.js-search-with-suggest').forEach((search) => {
        ReactDOM.createRoot(search).render(<Search config={search.dataset} />)
    })
}
